/* =====================================================
   GREEN DOSE v2 — JS interactions
   Minimal, vanilla, no deps.
   ===================================================== */
(function () {
  'use strict';

  // ---- Reveal on scroll (IntersectionObserver) ----
  function initReveal() {
    var els = document.querySelectorAll('.gd-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function bindToggle(item, head) {
    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    head.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
    function toggle() {
      var open = item.classList.toggle('open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    head.addEventListener('click', toggle);
    head.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  }

  // ---- FAQ accordion ----
  function initFaq() {
    // Keyboard + screen reader: the question row acts as the button.
    document.querySelectorAll('.gd-faq__item').forEach(function (item) {
      bindToggle(item, item.querySelector('.gd-faq__q') || item);
    });
  }

  // ---- Product accordion (reuses same .gd-product__acc-item) ----
  function initProductAccordion() {
    document.querySelectorAll('.gd-product__acc-item').forEach(function (item) {
      bindToggle(item, item.querySelector('.gd-product__acc-head, .gd-product__acc-q, summary') || item.firstElementChild || item);
    });
  }

  // ---- Product gallery thumbs ----
  function initProductGallery() {
    var main = document.querySelector('.gd-product__media-main img');
    if (!main) return;
    document.querySelectorAll('.gd-product__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var fullSrc = t.getAttribute('data-full') || (t.querySelector('img') && t.querySelector('img').src);
        if (!fullSrc) return;
        // Clear srcset so the browser uses our chosen src
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = fullSrc;
        document.querySelectorAll('.gd-product__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  // ---- Product variant pills ----
  function initVariants() {
    var pills = document.querySelectorAll('.gd-product__variant');
    if (!pills.length) return;
    var hidden = document.querySelector('#gd-product-variant-id');
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        pills.forEach(function (x) { x.classList.remove('is-active'); });
        p.classList.add('is-active');
        if (hidden) hidden.value = p.dataset.variantId || '';
        var priceEl = document.querySelector('.gd-product__price');
        if (priceEl && p.dataset.price) priceEl.textContent = p.dataset.price;
      });
    });
  }

  // ---- Quantity stepper (product page) ----
  function initQty() {
    document.querySelectorAll('.gd-product__qty').forEach(function (qty) {
      var input = qty.querySelector('input');
      if (!input) return;
      var minus = qty.querySelector('[data-qty="minus"]');
      var plus  = qty.querySelector('[data-qty="plus"]');
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });
    });
  }

  // ---- Build Your Box picker ----
  function initBYB() {
    var root = document.querySelector('[data-gd-byb]');
    if (!root) return;
    var TARGET = parseInt(root.dataset.gdBybTarget || '5', 10);
    var counter = root.querySelector('.gd-byb__counter strong');
    var counterWrap = root.querySelector('.gd-byb__counter');
    var cta = root.querySelector('.gd-byb__cta');
    var form = root.querySelector('form');
    var properties = form && form.querySelector('[data-byb-properties]');

    function total() {
      var sum = 0;
      root.querySelectorAll('.gd-byb__pick').forEach(function (p) {
        sum += parseInt(p.dataset.qty || '0', 10);
      });
      return sum;
    }
    function refresh() {
      var t = total();
      if (counter) counter.textContent = t;
      if (counterWrap) counterWrap.dataset.state = t === TARGET ? 'complete' : (t > TARGET ? 'over' : 'under');
      if (cta) cta.disabled = t !== TARGET;
      if (properties) {
        var picks = [];
        root.querySelectorAll('.gd-byb__pick').forEach(function (p) {
          var q = parseInt(p.dataset.qty || '0', 10);
          if (q > 0) picks.push(p.dataset.flavorName + ' × ' + q);
        });
        properties.value = picks.join(', ');
      }
    }

    root.querySelectorAll('.gd-byb__pick').forEach(function (pick) {
      var minus = pick.querySelector('[data-byb="minus"]');
      var plus = pick.querySelector('[data-byb="plus"]');
      var val = pick.querySelector('.gd-byb__pick-qty-val');
      function set(n) {
        n = Math.max(0, Math.min(TARGET, n));
        pick.dataset.qty = String(n);
        if (val) val.textContent = String(n);
        refresh();
      }
      if (minus) minus.addEventListener('click', function (e) {
        e.preventDefault();
        var n = parseInt(pick.dataset.qty || '0', 10);
        set(n - 1);
      });
      if (plus) plus.addEventListener('click', function (e) {
        e.preventDefault();
        var current = total();
        var n = parseInt(pick.dataset.qty || '0', 10);
        if (current < TARGET) set(n + 1);
      });
    });
    refresh();
  }

  // ---- Newsletter form (graceful no-op if not wired to Shopify form) ----
  function initNewsletter() {
    document.querySelectorAll('.gd-newsletter').forEach(function (form) {
      if (form.dataset.shopifyForm) return; // Shopify customer form wired directly
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button');
        if (btn) btn.textContent = 'Welcome';
      });
    });
  }

  // ---- Mobile sticky add-to-cart bar (shows after user scrolls past main ATC) ----
  function initStickyATC() {
    var sticky = document.querySelector('[data-gd-sticky-atc]');
    var trigger = document.querySelector('.gd-product__atc');
    if (!sticky || !trigger) return;
    // Reserve space for the bar so it never covers the footer or the last section
    document.body.classList.add('gd-has-sticky-atc');
    function update() {
      var rect = trigger.getBoundingClientRect();
      // 2026-10-17 · Green Dose 2: on phones the bar shows from the first screen (Fellow / Ghia), so buying is always one tap away
      var always = sticky.hasAttribute('data-gd2-always') && window.matchMedia('(max-width: 899px)').matches;
      var passed = always || rect.bottom < 0;
      sticky.classList.toggle('is-visible', passed);
      // Lets CSS push floating widgets (chat) above the bar only while it shows
      document.body.classList.toggle('gd-sticky-atc-shown', passed);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // ---- Boot ----
  function boot() {
    initReveal();
    initFaq();
    initProductAccordion();
    initProductGallery();
    initVariants();
    initQty();
    initBYB();
    initNewsletter();
    initStickyATC();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // ---- Shopify Theme Editor: re-init when sections reload ----
  // Without this, .gd-reveal elements added after page load stay at opacity:0
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.gd-reveal:not(.in)').forEach(function (el) {
      el.classList.add('in');
    });
    initFaq();
    initProductAccordion();
    initProductGallery();
    initVariants();
    initQty();
    initBYB();
    initStickyATC();
  });
  document.addEventListener('shopify:section:select', function () {
    document.querySelectorAll('.gd-reveal:not(.in)').forEach(function (el) {
      el.classList.add('in');
    });
  });
})();
